/* eslint-disable no-plusplus */
/**
 * Created by ivancai on 2018/2/5.
 * 此工具类请放置一些常用操作函数，如字符操作，存取cookie等
 */

export default {
  getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
  },
  getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toGMTString()}`;
    document.cookie = `${cname}=${cvalue}; ${expires}`;
  },
  downloadBlobFile(blob) {
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = 'qrcode.zip';
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(downloadUrl);
  },
}



// WEBPACK FOOTER //
// ./src/jslib/dk-utils.js